import { reportError } from '@ms/yammer-telemetry';
import type { AuthenticatorOptions } from '@ms/yammer-web-authenticators';
import { AcquireTokenAuthError, AcquireTokenPopupError } from '@ms/yammer-web-authenticators';

type ReportAuthError = NonNullable<AuthenticatorOptions['onError']>;

interface AuthErrorContext {
  readonly tenantId?: string;
  readonly meetingTenantId?: string;
}

export const reportAuthError = (
  error: Parameters<ReportAuthError>[0],
  { authenticatorType, scopes }: Parameters<ReportAuthError>[1],
  { tenantId, meetingTenantId }: AuthErrorContext = {}
): Promise<void> => {
  const eventProperties = {
    authenticatorType,
    ...(scopes ? { scopes: scopes.join(',') } : null),
    ...(tenantId || meetingTenantId ? { payload: JSON.stringify({ tenantId, meetingTenantId }) } : null),
  };

  if (error instanceof AcquireTokenAuthError) {
    reportError({
      error,
      eventProperties: {
        ...eventProperties,
        errorCode: 'AuthAcquireTokenSilentFailed',
      },
      skipAuthentication: true,
    });
  }

  if (error instanceof AcquireTokenPopupError) {
    reportError({
      error,
      eventProperties: {
        ...eventProperties,
        errorCode: 'AuthAcquireTokenPopupFailed',
      },
      skipAuthentication: true,
    });
  }

  return Promise.resolve();
};
